export default __webpack_public_path__ + "static/media/toarchive.6929bd96.svg";